// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs_gHBqO > .link_IZlRc {
  font: normal 13px/24px var( --fontFamily-primary );
  color: var( --color-base300 );
  padding: 0px;
  outline: none;
  display: block;
  transition: background-color var( --time-medium );
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.breadcrumbs_gHBqO > .link_IZlRc:hover {
  font: normal 13px/24px var( --fontFamily-primary );
  color: var( --color-linkNormal );
}
.breadcrumbs_gHBqO > .link_IZlRc:focus {
  font: normal 13px/24px var( --fontFamily-primary );
  color: var( --color-base300 );
}
.breadcrumbs_gHBqO > .link_IZlRc:active {
  font: normal 13px/24px var( --fontFamily-primary );
  color: var( --color-linkNormal );
}
.breadcrumbs_gHBqO > .separator_WqqHG {
  color: var( --color-base300 );
  padding: var( --size-padSmall );
  font-size: 16px;
}
.breadcrumbs_gHBqO > .current_D1mtA {
  font: 600 13px/24px Inter;
  color: var( --color-base500 );
}
.breadcrumbs_gHBqO.breadcrumbs-mobileItemScreen_nFIai {
  padding-left: 8px;
}
.breadcrumbs_gHBqO.breadcrumbs-mobileItemScreen_nFIai > .separator_WqqHG {
  color: transparent;
  padding: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr {
  font: 13px/20px Inter;
  color: var( --color-base700 );
  padding: 2px 10px;
  border-top: 1px solid var( --color-base200 );
  border-bottom: 0px solid var( --color-base200 );
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .link_IZlRc {
  font: 13px/20px Inter;
  color: #67798e;
  padding: 2px 4px;
  overflow: hidden;
  max-width: 186px;
  white-space: nowrap;
  border-radius: 2px;
  text-overflow: ellipsis;
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .link_IZlRc:hover {
  color: var( --color-base700 );
  background-color: var( --color-brand025 );
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .link_IZlRc:focus {
  color: var( --color-base700 );
  background-color: var( --color-brand050 );
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .link_IZlRc:active {
  font: 13px/20px Inter;
  color: var( --color-base700 );
  background-color: var( --color-brand050 );
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .separator_WqqHG {
  color: var( --color-base400 );
  padding: 4px;
  font-size: 12px;
  font-weight: bolder;
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr > .current_D1mtA {
  font: bold 13px/20px Inter;
  color: #67798e;
  padding: 2px 4px;
  overflow: hidden;
  max-width: 186px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.breadcrumbs_gHBqO.breadcrumbs-topNavBreadcrumbs_pK9jr.breadcrumbs-mobileTopNavBreadcrumbs_Ms4D4 {
  width: fit-content;
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/theme/Breadcrumbs.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iDAAiD;EACjD,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;AACA;EACE,kDAAkD;EAClD,6BAA6B;AAC/B;AACA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,4CAA4C;EAC5C,+CAA+C;AACjD;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".breadcrumbs > .link {\n  font: normal 13px/24px var( --fontFamily-primary );\n  color: var( --color-base300 );\n  padding: 0px;\n  outline: none;\n  display: block;\n  transition: background-color var( --time-medium );\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.breadcrumbs > .link:hover {\n  font: normal 13px/24px var( --fontFamily-primary );\n  color: var( --color-linkNormal );\n}\n.breadcrumbs > .link:focus {\n  font: normal 13px/24px var( --fontFamily-primary );\n  color: var( --color-base300 );\n}\n.breadcrumbs > .link:active {\n  font: normal 13px/24px var( --fontFamily-primary );\n  color: var( --color-linkNormal );\n}\n.breadcrumbs > .separator {\n  color: var( --color-base300 );\n  padding: var( --size-padSmall );\n  font-size: 16px;\n}\n.breadcrumbs > .current {\n  font: 600 13px/24px Inter;\n  color: var( --color-base500 );\n}\n.breadcrumbs.breadcrumbs-mobileItemScreen {\n  padding-left: 8px;\n}\n.breadcrumbs.breadcrumbs-mobileItemScreen > .separator {\n  color: transparent;\n  padding: 0px;\n  margin-left: 0px;\n  margin-right: 0px;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs {\n  font: 13px/20px Inter;\n  color: var( --color-base700 );\n  padding: 2px 10px;\n  border-top: 1px solid var( --color-base200 );\n  border-bottom: 0px solid var( --color-base200 );\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .link {\n  font: 13px/20px Inter;\n  color: #67798e;\n  padding: 2px 4px;\n  overflow: hidden;\n  max-width: 186px;\n  white-space: nowrap;\n  border-radius: 2px;\n  text-overflow: ellipsis;\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .link:hover {\n  color: var( --color-base700 );\n  background-color: var( --color-brand025 );\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .link:focus {\n  color: var( --color-base700 );\n  background-color: var( --color-brand050 );\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .link:active {\n  font: 13px/20px Inter;\n  color: var( --color-base700 );\n  background-color: var( --color-brand050 );\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .separator {\n  color: var( --color-base400 );\n  padding: 4px;\n  font-size: 12px;\n  font-weight: bolder;\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs > .current {\n  font: bold 13px/20px Inter;\n  color: #67798e;\n  padding: 2px 4px;\n  overflow: hidden;\n  max-width: 186px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.breadcrumbs.breadcrumbs-topNavBreadcrumbs.breadcrumbs-mobileTopNavBreadcrumbs {\n  width: fit-content;\n  min-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `breadcrumbs_gHBqO`,
	"link": `link_IZlRc`,
	"separator": `separator_WqqHG`,
	"current": `current_D1mtA`,
	"breadcrumbs-mobileItemScreen": `breadcrumbs-mobileItemScreen_nFIai`,
	"breadcrumbs-topNavBreadcrumbs": `breadcrumbs-topNavBreadcrumbs_pK9jr`,
	"breadcrumbs-mobileTopNavBreadcrumbs": `breadcrumbs-mobileTopNavBreadcrumbs_Ms4D4`
};
export default ___CSS_LOADER_EXPORT___;
